import React, { useMemo } from 'react'
import { filterBlockByType, isEmpty } from '../../../services/common'
import { icon } from '../../../services/icon'

const CanHelpMeItemLink = ({ block }) => {
    const blockChildrens = useMemo(() => {
        return isEmpty(block?.childrens) ? block?.attributes?.original_childrens : block?.childrens
    }, [block?.childrens])

    const blockWebResource = filterBlockByType(blockChildrens, 'RessourceWeb')
    const blockTitle = filterBlockByType(blockChildrens, 'Titre')

    return blockWebResource ? (
        <a
            target="_blank"
            className="baseocom-content-item-link"
            rel="noopener noreferrer"
            href={blockWebResource?.attributes?.URL}
        >
            {blockTitle?.content}
            {icon('arrow-down')}
        </a>
    ) : null
}

export default CanHelpMeItemLink
